{
  " Delete Company": " Delete Company",
  "%Auto": "%Auto",
  "%Total": "%Total",
  "1st year of": "1st year of",
  "500 - INTERNAL ERROR": "500 - INTERNAL ERROR",
  "Absence management": "Absence management",
  "Account structure": "Account structure",
  "Analytical accounting": "Analytical accounting",
  "Access SSI": "Access SSI",
  "access_denied": "access_denied",
  "Accesses": "Accesses",
  "Account": "Account",
  "Account disabled": "Account disabled",
  "Account Manager": "Account Manager",
  "Account Number": "Account Number",
  "Account prefix": "Account prefix",
  "Account type ": "Account type ",
  "ACCOUNT_MANAGER": "Account Manager",
  "Accounting": "Accounting",
  "Accounting balance review": "Accounting balance review",
  "Accounting Balance Review": "Accounting Balance Review",
  "Accounting balance review completed": "Accounting balance review completed",
  "Accounting firm": "Accounting firm",
  "Accounting Firm": "Accounting Firm",
  "Accounting firm addresses": "Accounting firm addresses",
  "Accounting firm banks": "Accounting firm banks",
  "Accounting firm contacts": "Accounting firm contacts",
  "Accounting firm platforms": "Accounting firm platforms",
  "Accounting firm settings": "Accounting firm settings",
  "Accounting firm uses Neoscan-Expert": "Accounting firm uses Neoscan Expert",
  "Accounting firms": "Accounting firms",
  "Accounting Firms": "Accounting Firms",
  "Accounting Plan Type": "Accounting Plan Type",
  "Accountingfirm company": "Accountingfirm company",
  "Accounts linked to the bank": "Accounts linked to the bank",
  "Accounts without integration": "Accounts without integration",
  "Action": "Action",
  "Actions": "Actions",
  "Active": "Active",
  "Active cycle": "Active cycle",
  "Activity code": "Activity code",
  "Add": "Add",
  "Add Access to user": "Add Access to user",
  "Add Account": "Add Account",
  "Add Accounting Firm": "Add Accounting Firm",
  "Add address": "Add address",
  "Add Address": "Add Address",
  "Add Assignment": "Add Assignment",
  "Add Assignments": "Add Assignments",
  "Add Attachments": "Add Attachments",
  "Add bank": "Add bank",
  "Add Bank": "Add Bank",
  "Add bank account": "Add bank account",
  "Add book": "Add book",
  "Add category": "Add category",
  "Add client": "Add client",
  "Add Client": "Add Client",
  "Add client user": "Add client user",
  "Add Colaborator": "Add Colaborator",
  "Add Collecting Organization": "Add Collecting Organization",
  "Add company": "Add company",
  "Add Company": "Add Company",
  "Add compte Client": "Add compte Client",
  "Add compte Provider": "Add compte Provider",
  "Add counterpart": "Add counterpart",
  "Add Counterpart": "Add Counterpart",
  "Add custom graphic": "Add custom graphic",
  "Add cycle": "Add cycle",
  "Add Director": "Add Director",
  "Add Director/StakeHolder": "Add Director/StakeHolder",
  "Add Email": "Add Email",
  "Add Establishment": "Add Establishment",
  "Add existing client user": "Add existing client user",
  "Add existing user": "Add existing user",
  "Add external Service": "Add external Service",
  "Add line": "Add line",
  "Add Member": "Add Member",
  "Add new bank": "Add new bank",
  "Add new bank account": "Add new bank account",
  "Add new company": "Add new company",
  "Add new user": "Add new user",
  "Add Phone": "Add Phone",
  "Add platform": "Add platform",
  "Add Provider": "Add Provider",
  "Add Stakeholder": "Add Stakeholder",
  "Add user": "Add user",
  "Add Vat": "Add Vat",
  "Add Worktime": "Add Worktime",
  "Addons": "Addons",
  "Address": "Address",
  "Address 1": "Address 1",
  "Address 2": "Address 2",
  "Address 3": "Address 3",
  "Address type": "Address type",
  "Address Type": "Address Type",
  "Address_plural": "Address",
  "Address1": "Address1",
  "Address2": "Address2",
  "Address3": "Address3",
  "Addresses": "Addresses",
  "admin_cabinet": "Administrator",
  "admin_newrai": "Administrative",
  "Advanced Export": "Advanced Export",
  "Advanced import": "Advanced import",
  "All": "All",
  "Allowance for professional expenses": "Allowance for professional expenses",
  "Amount": "Amount",
  "An error occurred, please refresh the page or click the button below": "An error occurred, please refresh the page or click the button below",
  "An unexpected error occurred processing your request, please try again later.": "An unexpected error occurred processing your request, please try again later.",
  "Analyze": "Analyze",
  "API URL": "API URL",
  "apiUrl": "apiUrl",
  "APIURL": "APIURL",
  "App": "App",
  "Application": "Application",
  "Arbitration of leave": "Arbitration of leave",
  "Are you sure about custom graphic?": "Are you sure about custom graphic?",
  "Are you sure about delete this": "Are you sure about delete this",
  "Are you sure about delete this address?": "Are you sure about delete this address?",
  "Are you sure about delete this assignment?": "Are you sure about delete this assignment?",
  "Are you sure about delete this bank account?": "Are you sure about delete this bank account?",
  "Are you sure about delete this bank?": "Are you sure about delete this bank?",
  "Are you sure about delete this cycle?": "Are you sure about delete this cycle?",
  "Are you sure about delete this establishment?": "Are you sure about delete this establishment?",
  "Are you sure about delete this keyword?": "Are you sure about delete this keyword?",
  "Are you sure about delete this platform?": "Are you sure about delete this platform?",
  "Are you sure about delete this user": "Are you sure about delete this user",
  "Are you sure about delete this vat?": "Are you sure about delete this vat?",
  "Are you sure that you want to delete the accesses to this accounting firm?": "Are you sure that you want to delete the accesses to this accounting firm?",
  "Are you sure that you want to remove this user from this company?": "Are you sure that you want to remove this user from this company?",
  "Are you sure you want to delete this bank?": "Are you sure you want to delete this bank?",
  "Are you sure you want to delete this category?": "Are you sure you want to delete this category?",
  "Are you sure you want to delete this company?": "Are you sure you want to delete this company?",
  "Are you sure you want to delete this vat?": "Are you sure you want to delete this vat?",
  "Are you sure you want to do a new import?": "Are you sure you want to do a new import?",
  "Are you sure you want to re-export this/these journal entry(ies) to the accounting software?": "Are you sure you want to re-export this/these journal entry(ies) to the accounting software?",
  "Are you sure you want to remove this user ?": "Are you sure you want to remove this user ?",
  "Are you sure you want to save the data in this period? After saving it is not possible to change this period.": "Are you sure you want to save the data in this period? After saving it is not possible to change this period.",
  "Are you sure you want to start this bulk?": "Are you sure you want to start this bulk?",
  "Are you sure you want to start this scanbulk?": "Are you sure you want to start this scanbulk?",
  "Are you sure you want to unsubscribe the newsletter?": "Are you sure you want to unsubscribe the newsletter?",
  "Assign this bulk": "Assign this bulk",
  "Assigned to": "Assigned to",
  "Assignment Type": "Assignment Type",
  "Assignments": "Assignments",
  "at": "at",
  "At least 1 email": "At least 1 email",
  "At least 1 phone": "At least 1 phone",
  "atc": "Technico accounting agent",
  "ATC": "ATC",
  "ATC Name": "ATC Name",
  "ATC Statistics": "ATC Statistics",
  "Attachment successfully inserted": "Attachment successfully inserted",
  "Auto Export FACT": "Auto Export FACT",
  "Auto Export NCS": "Auto Export NCS",
  "Auto Export NeoCheque": "Auto Export NeoCheque",
  "Auto Export NeoFrais": "Auto Export NeoFrais",
  "Auto Export NeoTreso": "Auto Export NeoTreso",
  "Auto Export SSI": "Auto Export SSI",
  "Auto exported": "Auto exported",
  "Auto Import Success": "Auto Import Success",
  "Auto Liquidation": "Auto Liquidation",
  "Available": "Available",
  "Available soon": "Available soon",
  "Back to list": "Back to list",
  "Bank": "Bank",
  "Bank account": "Bank account",
  "Bank account deleted": "Bank account deleted",
  "Bank accounts": "Bank accounts",
  "Bank compte was saved with success": "Bank compte was saved with success",
  "Bank description": "Bank description",
  "Bank Description": "Bank Description",
  "Bank does not exist": "Bank does not exist",
  "Bank Form": "Bank Form",
  "Bank saved with success": "Bank saved with success",
  "Banks": "Banks",
  "Banks connections": "Banks connections",
  "Bar chart": "Bar chart",
  "Benefits": "Benefits",
  "BIC / SWIFT": "BIC / SWIFT",
  "BILLING": "BILLING",
  "Book Bank": "Book Bank",
  "Book cashed checks (Income)": "Book cashed checks (Income)",
  "Book issued checks (Expense)": "Book issued checks (Expense)",
  "Book Saved with Success": "Book Saved with Success",
  "Book Type": "Book Type",
  "Books": "Books",
  "BTQ": "BTQ",
  "Bulk": "Bulk",
  "Business Activity": "Business Activity",
  "Business Name": "Business Name",
  "Buys": "Buys",
  "Calculation": "Calculation",
  "Calendar of obligations": "Calendar of obligations",
  "Calendar of obligations - Vat": "Calendar of obligations - Vat",
  "Cancel": "Cancel",
  "Capital Amount": "Capital Amount",
  "Cashed sales": "Cashed sales",
  "Cashed turnover": "Cashed turnover",
  "Category": "Category",
  "CDI CDIR": "CDI CDIR",
  "Center Dep. Plate": "Center Dep. Plate",
  "Centros": "Centros",
  "CFE": "CFE",
  "Change declare TVA": "Change declare TVA",
  "Change Password": "Change Password",
  "Chargé portefeuille": "Chargé portefeuille",
  "Chorus": "Chorus",
  "City": "City",
  "Clé": "Clé",
  "Clear": "Clear",
  "Click or drag file to this area to upload": "Click or drag file to this area to upload",
  "Client": "Client",
  "Client account": "Client account",
  "Client ID": "Client ID",
  "Client Info": "Client Info",
  "Client Saved with Success": "Client Saved with Success",
  "Client secret": "Client secret",
  "Client secrets": "Client secrets",
  "Client support": "Client support",
  "Client type": "Client type",
  "Client was removed from this company with success": "Client was removed from this company with success",
  "Client was saved with success": "Client was saved with success",
  "Client_user": "Client_user",
  "Clients": "Clients",
  "Close": "Close",
  "Closing month of leave": "Closing month of leave",
  "cm": "Mission chief",
  "CNX": "CNX",
  "Code": "Code",
  "Code de TVA": "Code de TVA",
  "Code Service": "Code Service",
  "Code TVA": "Code TVA",
  "COFI": "COFI",
  "Collaborator": "Collaborator",
  "COLLABORATOR": "Collaborator",
  "Collaborator was created with success": "Collaborator was created with success",
  "Collaborator was saved with success": "Collaborator was saved with success",
  "Collaborators": "Collaborators",
  "Collabs": "Collabs",
  "Collections": "Collections",
  "Collective": "Collective",
  "Collective agreement": "Collective agreement",
  "Collective by default": "Collective by default",
  "Collector Institutions": "Collector Institutions",
  "Commentary": "Commentary",
  "Comments": "Comments",
  "Companies": "Companies",
  "Company": "Company",
  "Company Name": "Company Name",
  "Company successfully deleted ": "Company successfully deleted ",
  "Company weekly schedule": "Company weekly schedule",
  "Complementary Addresses": "Complementary Addresses",
  "Compt. Auto": "Compt. Auto",
  "Config Business Activity": "Config Business Activity",
  "Configured": "Configured",
  "Confirm": "Confirm",
  "Confirm deletion": "Confirm deletion",
  "Confirm that you want to deactivate the connection?": "Confirm that you want to deactivate the connection?",
  "Confirmation": "Confirmation",
  "Connect to bank": "Connect to bank",
  "Connected": "Connected",
  "Connection": "Connection",
  "Connection Errors": "Connection Errors",
  "Contacts": "Contacts",
  "Copy email": "Copy email",
  "Counter Collective": "Counter Collective",
  "Counterpart": "Counterpart",
  "Counterpart autoliquidation": "Counterpart autoliquidation",
  "Counterpart Bank": "Counterpart Bank",
  "Counterpart Buy": "Counterpart Buy",
  "Counterpart cashed checks (Income)": "Counterpart cashed checks (Income)",
  "Counterpart code": "Counterpart code",
  "Counterpart code SSI": "Counterpart code SSI",
  "Counterpart code Tréso": "Counterpart code Tréso",
  "Counterpart Immobilization": "Counterpart Immobilization",
  "Counterpart issued checks (Expense)": "Counterpart issued checks (Expense)",
  "Counterpart saved with success": "Counterpart saved with success",
  "Counterpart Sell": "Counterpart Sell",
  "Counterpart SSI": "Counterpart SSI",
  "Counterpart Tréso": "Counterpart Tréso",
  "Counterpart type ": "Counterpart type ",
  "counterpart_len": "The code must be {{count}} characters long",
  "counterpart_len_one": "The code must be {{count}} characters long",
  "counterpart_len_other": "The code must be {{count}} characters long",
  "Country": "Country",
  "Couterparts by cycle": "Couterparts by cycle",
  "cp_alternative": "Chargé Portefeuille",
  "Create": "Create",
  "Create account": "Create account",
  "Create accounts without integration": "Create accounts without integration",
  "Create bank account": "Create bank account",
  "Create bank counterparts": "Create bank counterparts",
  "Create bank cycle": "Create bank cycle",
  "Create counterpart": "Create counterpart",
  "Create le compte bancaire": "Create le compte bancaire",
  "Create new user": "Create new user",
  "Create/manage accounts linked to the bank": "Create/manage accounts linked to the bank",
  "Created": "Created",
  "Created by": "Created by",
  "Created By Newrai": "Created By Newrai",
  "created successfully": "created successfully",
  "Creation Date": "Creation Date",
  "Currency": "Currency",
  "Currency Tracking": "Currency Tracking",
  "current customers": "current customers",
  "Current Debits": "Current Debits",
  "Current month and year": "Current month and year",
  "Custom graphics": "Custom graphics",
  "CVAE Déclaration": "CVAE Déclaration",
  "CVAE Paiement": "CVAE Paiement",
  "Cycle": "Cycle",
  "Cycle Saved with Success": "Cycle Saved with Success",
  "Cycles": "Cycles",
  "Date": "Date",
  "Date - Time": "Date - Time",
  "Date format:": "Date format:",
  "Date of last election": "Date of last election",
  "Date of payment of wages": "Date of payment of wages",
  "Day": "Day",
  "Deactivate the company": "Deactivate the company",
  "Debits": "Debits",
  "Declare VAT": "Declare VAT",
  "Declared sales": "Declared sales",
  "declareVatActive": "When making this change you will need to enter the VAT values of the {{count}} documents in the SSI, are you sure?",
  "declareVatActive_one": "declareVatActive",
  "declareVatActive_other": "declareVatActive",
  "declareVatActive_plural": "declareVatActive",
  "declareVatInactive": "Making this change will remove the VAT values from {{count}} documents in the SSI, are you sure?",
  "declareVatInactive_one": "declareVatInactive",
  "declareVatInactive_other": "declareVatInactive",
  "declareVatInactive_plural": "declareVatInactive",
  "Default book": "Default book",
  "Default book Bank": "Default book Bank",
  "Default clients constants": "Default clients constants",
  "Default clients counterparts": "Default clients counterparts",
  "Default counterpart": "Default counterpart",
  "Default Counterpart": "Default Counterpart",
  "Default counterpart Bank": "Default counterpart Bank",
  "Default document naming": "Default document naming",
  "Default notification e-mail": "Default notification e-mail",
  "Default notification email": "Default notification email",
  "Default providers counterparts": "Default providers counterparts",
  "Default SSI type": "Default SSI type",
  "Default SSI Type": "Default SSI Type",
  "Delete": "Delete",
  "Delete bank": "Delete bank",
  "Delete bank account": "Delete bank account",
  "Delete custom graphic": "Delete custom graphic",
  "Delete keyword": "Delete keyword",
  "Delete success": "Delete success",
  "Delete this company": "Delete this company",
  "Delete user access": "Delete user access",
  "Delete vat": "Delete vat",
  "Deleted Successfully": "Deleted Successfully",
  "Deliver statement": "Deliver statement",
  "DELIVERY": "DELIVERY",
  "Description": "Description",
  "Details": "Details",
  "director": "Director",
  "Director": "Director",
  "Director/StakeHolder saved with success": "Director/StakeHolder saved with success",
  "Directors": "Directors",
  "Disable bank account": "Disable bank account",
  "Do you intend to remove this assignments": "Do you intend to remove this assignments",
  "Do you intend to remove this director": "Do you intend to remove this director",
  "Do you intend to remove this stakeholder": "Do you intend to remove this stakeholder",
  "Do you realy want revert the changes?": "Do you realy want revert the changes?",
  "Do you realy want update accounting Firm data?": "Do you realy want update accounting Firm data?",
  "Do you realy want update company data?": "Do you realy want update company data?",
  "Do you want to duplicate the plan comptable data from cycle": "Do you want to duplicate the plan comptable data from cycle",
  "Docs not charged": "Docs not charged",
  "Document count": "Document count",
  "Documents": "Documents",
  "Documents validated / total": "Documents validated / total",
  "Done": "Done",
  "Dossier": "Dossier",
  "Dossier progres": "Dossier progres",
  "Dossier progress": "Dossier progress",
  "Download": "Download",
  "duplicate": "Do you want to duplicate the plan comptable data from cycle {{x}} to cycle {{y}}?",
  "Duplicate the plan comptable": "Duplicate the plan comptable",
  "Duplicate the plan comptable saved with success": "Duplicate the plan comptable saved with success",
  "Duration": "Duration",
  "Economic and social committee": "Economic and social committee",
  "EDI TVA": "EDI TVA",
  "Edit": "Edit",
  "Edit accounting firm": "Edit accounting firm",
  "Edit addons": "Edit addons",
  "Edit address": "Edit address",
  "Edit Address": "Edit Address",
  "Edit Assignments": "Edit Assignments",
  "Edit bank": "Edit bank",
  "Edit bank account": "Edit bank account",
  "Edit bank counterparts": "Edit bank counterparts",
  "Edit bank cycle": "Edit bank cycle",
  "Edit client user": "Edit client user",
  "Edit Director/StakeHolder": "Edit Director/StakeHolder",
  "Edit keyword": "Edit keyword",
  "Edit platform": "Edit platform",
  "Electronic payments": "Electronic payments",
  "Elements to exclude": "Elements to exclude",
  "Email": "Email",
  "Email not valid": "Email not valid",
  "Email_plural": "Email",
  "Employer/Employee breakdown": "Employer/Employee breakdown",
  "Enable two-factor authentication": "Enable two-factor authentication",
  "End": "End",
  "End connection with powens": "End connection with powens",
  "End date": "End date",
  "End Date": "End Date",
  "End of exercise": "End of exercice",
  "End Term Date": "End Term Date",
  "End time": "End time",
  "Engagement": "Engagement",
  "English": "English",
  "Enter the day of the TVA declaration in the Fiscal tab": "Enter the day of the TVA declaration in the Fiscal tab",
  "Enter your code here, please!": "Enter your code here, please!",
  "Entity Type": "Entity Type",
  "ENTREPRISE": "Business",
  "error": "error",
  "Error": "Error",
  "Error 404": "Error 404",
  "Error code": "Error code",
  "Error inserting an attachment": "Error inserting an attachment",
  "Error on add service": "Error on add service",
  "Error on delete": "Error on delete",
  "Error on delete Address": "Error on delete Address",
  "Error on delete Platform": "Error on delete Platform",
  "Error on export": "Error on export",
  "Error on get data": "Error on get data",
  "Error on get options": "Error on get options",
  "Error on save": "Error on save",
  "Error on update Address": "Error on update Address",
  "Error on update banks": "Error on update banks",
  "Error on update Platform": "Error on update Platform",
  "Error on update service": "Error on update service",
  "Error on update settings": "Error on update settings",
  "Error synchronisation": "Error synchronisation",
  "Errors": "Errors",
  "Establishment": "Establishment",
  "Establishments": "Establishments",
  "Example": "Example",
  "Exclude elements": "Exclude elements",
  "Exercise is mandatory": "Exercise is mandatory",
  "Exercises": "Exercices",
  "Exit without save": "Exit without save",
  "Expected date of receipt": "Expected date of receipt",
  "Expenses categories": "Expenses categories",
  "Export": "Export",
  "Export  Ascii": "Export  Ascii",
  "Export Ascii": "Export Ascii",
  "Export Auto": "Export Auto",
  "Export Auto SSI": "Export Auto SSI",
  "Export error": "Export error",
  "Export message": "Export message",
  "Export XLSX": "Export XLSX",
  "External Services": "External Services",
  "External Services Add": "External Services Add",
  "Failed to save client addons": "Failed to save client addons",
  "Failed to save user": "Failed to save user",
  "Failed to update user permissions": "Failed to update user permissions",
  "Fax": "Fax",
  "File progress": "File progress",
  "Finished": "Finished",
  "First name": "First name",
  "First Name": "First Name",
  "form": "Training",
  "France": "France",
  "French": "French",
  "Frequency": "Frequency",
  "Friday": "Friday",
  "From": "From",
  "FRP Code": "FRP Code",
  "FULL": "Outsourcing",
  "General": "General",
  "General Account": "General Account",
  "General Accounts": "General Accounts",
  "General Constants": "General Constants",
  "General constants saved with success": "General constants saved with success",
  "General info": "General info",
  "General settings": "General settings",
  "General lenght": "General lenght",
  "General_Info": "General_Info",
  "Go back": "Go back",
  "Go Back": "Go Back",
  "Go to Home": "Go to Home",
  "Governament mileage costs detailed": "Governament mileage costs detailed",
  "Grand total": "Grand total",
  "Graphic": "Graphic",
  "HALF": "No Outsourcing",
  "Headquarters": "Headquarters",
  "HelpDesk": "HelpDesk",
  "Highlighted row": "Highlighted row",
  "History": "History",
  "Holiday": "Holiday",
  "Home": "Home",
  "Hr Accountant": "Hr Accountant",
  "HR_ACCOUNTANT": "Hr Accountant",
  "HT": "HT",
  "Iban": "Iban",
  "IBAN": "IBAN",
  "Id": "Id",
  "ID": "ID",
  "If NINEA has 7 digits, add 00 at the beginning": "If NINEA has 7 digits, add 00 at the beginning",
  "If the company is deactivated, it will no longer appear in the lists": "If the company is deactivated, it will no longer appear in the lists",
  "If you delete this company you will no longer be able to access it": "If you delete this company you will no longer be able to access it",
  "Image must be smaller than 2MB!": "Image must be smaller than 2MB!",
  "Immutable elements": "Immutable elements",
  "Impor Type": "Impor Type",
  "Import": "Import",
  "Import / Export": "Import / Export",
  "Import Auto": "Import Auto",
  "Import Code": "Import Code",
  "Import Export Auto": "Import Export Auto",
  "Import file": "Import file",
  "Import Manual": "Import Manual",
  "Import plan comptable": "Import plan comptable",
  "Import Success": "Import Success",
  "Imported": "Imported",
  "In processing": "In processing",
  "Inactive": "Inactive",
  "Inactive cycle": "Inactive cycle",
  "Increase your account's security by enabling two-factor authentication (2FA) : ": "Increase your account's security by enabling two-factor authentication (2FA) : ",
  "Increase your account's security by enabling two-factor authentication (2FA).": "Increase your account's security by enabling two-factor authentication (2FA).",
  "Independet Worker": "Independet Worker",
  "Info": "Info",
  "Information receiver": "Information receiver",
  "Insert the code exactly as the accounting software platform.": "Insert the code exactly as the accounting software platform.",
  "Institution type": "Institution type",
  "Instructions": "Instructions",
  "Internal code": "Internal code",
  "Internal Code": "Internal Code",
  "Internal reference": "Internal reference",
  "Internal Reference": "Internal Reference",
  "Invalid format": "Invalid format",
  "IR": "IR - Tax / Income",
  "IS": "IS - Tax / Company",
  "Is active": "Is active",
  "Is Active": "Is Active",
  "Is connected": "Is connected",
  "is required": "is required",
  "IS_unique": "IS_unique",
  "It is not possible to enter the application": "It is not possible to enter the application",
  "It was removed with success": "It was removed with success",
  "Job": "Job",
  "Keyword": "Keyword",
  "Keywords": "Keywords",
  "Label": "Label",
  "Language": "Language",
  "Last name": "Last name",
  "Last Name": "Last Name",
  "Last sync": "Last sync",
  "Last Update": "Last Update",
  "Legal": "Legal",
  "Legal Accountant": "Legal Accountant",
  "Legal Category": "Legal Category",
  "Legal Structure": "Legal Structure",
  "LEGAL_ACCOUNTANT": "Legal Accountant",
  "Legal_Directors": "Legal_Directors",
  "Legal_Info": "Legal_Info",
  "Legal_Stakeholders": "Legal_Stakeholders",
  "Legal_Tax": "Legal_Tax",
  "Legend": "Legend",
  "Length of counterparts": "Length of counterparts",
  "Limit date": "Limit date",
  "limit_characters": "limit_characters",
  "Line": "Line",
  "Line chart": "Line chart",
  "List Articles": "List Articles",
  "List Companies": "List Companies",
  "Load more": "Load more",
  "Loading": "Loading",
  "Loading...": "Loading...",
  "Login": "Login",
  "Logo": "Logo",
  "Logout": "Logout",
  "Lot details": "Lot details",
  "Lot ID": "Lot ID",
  "Machine Learning progress": "Machine Learning progress",
  "MAIN": "MAIN",
  "Main Accountant": "Main Accountant",
  "Main bank": "Main bank",
  "Main Bank": "Main Bank",
  "MAIN_ACCOUNTANT": "Main Accountant",
  "Manage in Powens": "Manage in Powens",
  "Manual Export": "Manual Export",
  "Manual Export FACT": "Manual Export FACT",
  "Manual Export ncs": "Manual Export ncs",
  "Manual Export NCS": "Manual Export NCS",
  "Manual Export NeoCheque": "Manual Export NeoCheque",
  "Manual Export NeoFrais": "Manual Export NeoFrais",
  "Manual Export NeoTreso": "Manual Export NeoTreso",
  "Manual Export ssi": "Manual Export ssi",
  "Manual Export SSI": "Manual Export SSI",
  "Manual Import": "Manual Import",
  "max_mileage_cost": "max_mileage_cost",
  "Membership nr": "Membership nr",
  "Membership of a professional union": "Membership of a professional union",
  "Method": "Method",
  "min_mileage_cost": "min_mileage_cost",
  "Missions": "Missions",
  "Modifier le compte bancaire": "Modifier le compte bancaire",
  "Monday": "Monday",
  "Month": "Month",
  "Month of absence": "Month of absence",
  "Month/Year": "Month/Year",
  "Monthly": "Monthly",
  "MONTHLY": "Monthly",
  "Months": "Months",
  "Mopeds": "Mopeds",
  "Most used counterpart": "Most used counterpart",
  "Must be {{length}} characters long": "Must be {{length}} characters long",
  "Must start with {{prefix}}": "Must start with {{prefix}}",
  "Name": "Name",
  "Name Generator": "Name Generator",
  "Net amount": "Net amount",
  "New": "New",
  "New bank account": "New bank account",
  "New company": "New company",
  "New Password": "New Password",
  "New product": "New product",
  "newRai": "newRai",
  "NewRai Digital Uses Neoscan": "NewRai Digital Uses Neoscan",
  "Newrai support": "Newrai support",
  "Newrai user": "Newrai user",
  "Newrai User": "Newrai User",
  "Newrai user data": "Newrai user data",
  "Newsletter": "Newsletter",
  "Newsletter subscribed successfully": "Newsletter subscribed successfully",
  "Newsletter unsubscribed uccessfully": "Newsletter unsubscribed uccessfully",
  "Nic": "Nic",
  "NIC": "NIC",
  "NIC_fr": "NIC_fr",
  "NIC_sn": "NIC_sn",
  "NII": "NII",
  "NINEA": "NINEA",
  "NINEA must have 9 digits": "NINEA must have 9 digits",
  "no": "no",
  "No": "No",
  "No accounting cycles found. Please import the plan comptable first.": "No accounting cycles found. Please import the plan comptable first.",
  "No balance review sheet exists for the selected cycle": "No balance review sheet exists for the selected cycle",
  "No comments": "No comments",
  "No Data": "No Data",
  "No options": "No options",
  "No Options": "No Options",
  "No platform": "No platform",
  "No records found": "No records found",
  "Nominate Date": "Nominate Date",
  "NONE": "No Outsourcing",
  "Notifications": "Notifications",
  "Notify": "Notify",
  "Nr": "Nr",
  "NR": "NR",
  "Nr Shares": "Nr Shares",
  "Number": "Number",
  "Numéro de Compte": "Numéro de Compte",
  "OCR statistical report": "Machine Learning statistical report",
  "Ok": "Ok",
  "Old Password": "Old Password",
  "Oops Page Not Found": "Oops Page Not Found",
  "ops": "Operator",
  "Optimizable elements": "Optimizable elements",
  "OPTIONAL": "OPTIONAL",
  "Order": "Order",
  "Other": "Other",
  "OTHER": "OTHER",
  "Others": "Others",
  "Outside paied package": "Outside paied package",
  "Overtime hours charged": "Overtime hours charged",
  "Paid leave management": "Paid leave management",
  "Participation agreement": "Participation agreement",
  "PARTICULAR": "Particular",
  "Password": "Password",
  "Password change": "Password change",
  "Pay Offset": "Pay Offset",
  "payment method": "payment method",
  "Payment method": "Payment method",
  "Payment methods": "Payment methods",
  "Payment Methods": "Payment Methods",
  "Payment VLU": "Payment VLU",
  "Payroll taxes": "Payroll taxes",
  "Percentage": "Percentage",
  "Period": "Period",
  "Periodic": "Periodic",
  "Permission error": "Permission error",
  "Permission error occurred, if this continues contact support.": "Permission error occurred, if this continues contact support.",
  "Permissions": "Permissions",
  "Personal identification number": "Personal identification number",
  "Phone": "Phone",
  "Phone 1": "Phone 1",
  "Phone 2": "Phone 2",
  "Phone_plural": "Phone",
  "Pie chart": "Pie chart",
  "Plan Code": "Plan Code",
  "Platform": "Platform",
  "Platform deleted with success": "Platform deleted with success",
  "Platform type": "Platform type",
  "Platform Type": "Platform Type",
  "Please confirm that the MDB file you want to import corresponds to the company you selected. Are you sure you want to import the MDB file?": "Please confirm that the MDB file you want to import corresponds to the company you selected. Are you sure you want to import the MDB file?",
  "Please contact admin.": "Please contact admin.",
  "Please contact your company's accountant": "Please contact your company's accountant",
  "Please correct the errors before saving": "Please correct the errors before saving",
  "Please go back to the list and select another one.": "Please go back to the list and select another one.",
  "Please input email or delete this field.": "Please input email or delete this field.",
  "Please input phone or delete this field.": "Please input phone or delete this field.",
  "Please insert MDB file": "Please insert MDB file",
  "Please note that this import will irreversibly affect the data!": "Please note that this import will irreversibly affect the data!",
  "Please select the services at Accounting firm": "Please select the services at Accounting firm",
  "Postal code": "Postal code",
  "Postal Code": "Postal Code",
  "Power": "Power",
  "Previous": "Previous",
  "Price / KM": "Price / KM",
  "Privacy": "Privacy",
  "Profile": "Profile",
  "Profit": "Profit",
  "Profit-sharing agreement": "Profit-sharing agreement",
  "Progress": "Progress",
  "Progress OCR": "Progress Avancement Machine",
  "Progress SSI": "Progress SSI",
  "Provider": "Provider",
  "Provider account": "Provider account",
  "Provider Saved with Success": "Provider Saved with Success",
  "Providers": "Providers",
  "PUBLIC_ADMINISTRATION": "Public administration",
  "Purchase allocation": "Purchase allocation",
  "Quantity Tracking": "Quantity Tracking",
  "Quantity Tracking2": "Quantity Tracking2",
  "QUARTER": "Quarter",
  "quarterly": "quarterly",
  "Rate": "Rate",
  "RCM": "RCM",
  "RCS": "RCS",
  "Read More": "Read More",
  "readyForExport": "readyForExport",
  "readyForExportProcessing": "readyForExportProcessing",
  "readyForExportReadyAndProcessing": "readyForExportReadyAndProcessing",
  "Receive notifications by email": "Receive notifications by email",
  "Receive the newsletter": "Receive the newsletter",
  "Recipe": "Recipe",
  "Reconciliation": "Reconciliation",
  "Reconnect": "Reconnect",
  "Record": "Record",
  "Recover company": "Recover company",
  "Reexport": "Reexport",
  "Refresh": "Refresh",
  "Refresh page": "Refresh page",
  "Refresh Page": "Refresh Page",
  "Regime": "Regime",
  "registration": "registration",
  "Remote accounting firm id": "Remote accounting firm id",
  "Remote Accounting Firm ID": "Remote Accounting Firm ID",
  "Remove address": "Remove address",
  "Remove Address": "Remove Address",
  "Remove Bank": "Remove Bank",
  "Remove client user from company": "Remove client user from company",
  "Remove Platform": "Remove Platform",
  "Remove user from company": "Remove user from company",
  "removed successfully": "removed successfully",
  "Repeat New Password": "Repeat New Password",
  "Request password reset": "Request password reset",
  "Request Password Reset Form": "Request Password Reset Form",
  "Required action": "Required action",
  "Reset": "Reset",
  "Reset user password": "Reset user password",
  "Restaurant tickets": "Restaurant tickets",
  "Return": "Return",
  "rev": "Reviewer",
  "Salary maintenance": "Salary maintenance",
  "Sales allocation": "Sales allocation",
  "Saturday": "Saturday",
  "Sauv.": "Sauv.",
  "Save": "Save",
  "Save & Close": "Save & Close",
  "Save & Next": "Save & Next",
  "Save accounting firm with success": "Save accounting firm with success",
  "Save and Exit": "Save and Exit",
  "Save success": "Save success",
  "Save Success": "Save Success",
  "Save Successfully": "Save Successfully",
  "Saved": "Saved",
  "Saved successfully": "Saved successfully",
  "Saved Successfully": "Saved Successfully",
  "Search": "Search",
  "Select": "Select",
  "Select a country": "Select a country",
  "Select a service or there are added services that have not yet been saved": "Select a service or there are added services that have not yet been saved",
  "Select a type": "Select a type",
  "Select a user": "Select a user",
  "Select accounting": "Select accounting",
  "Select accounting firm": "Select accounting firm",
  "Select Accounting Firm First": "Select Accounting Firm First",
  "Select adress type": "Select adress type",
  "Select an option": "Select an option",
  "Select book": "Select book",
  "Select book bank": "Select book bank",
  "Select book type": "Select book type",
  "Select business activity": "Select business activity",
  "Select city": "Select city",
  "Select code": "Select code",
  "Select company": "Select company",
  "Select counter collective": "Select counter collective",
  "Select counterpart": "Select counterpart",
  "Select Counterpart": "Select Counterpart",
  "Select counterpart bank": "Select counterpart bank",
  "Select counterpart buy": "Select counterpart buy",
  "Select counterpart immobilization": "Select counterpart immobilization",
  "Select counterpart sell": "Select counterpart sell",
  "Select country": "Select country",
  "Select cycle": "Select cycle",
  "Select cycle type": "Select cycle type",
  "Select date": "Select date",
  "Select default counterpart": "Select default counterpart",
  "Select establishment": "Select establishment",
  "Select job": "Select job",
  "Select legal category": "Select legal category",
  "Select legal structure": "Select legal structure",
  "Select period": "Select period",
  "Select plan code": "Select plan code",
  "Select platform": "Select platform",
  "Select postal code": "Select postal code",
  "Select Services": "Select Services",
  "Select services by user": "Select services by user",
  "Select the platform": "Select the platform",
  "Select the SSI Type": "Select the SSI Type",
  "Select type": "Select type",
  "Select user": "Select user",
  "Select vat": "Select vat",
  "Selected": "Selected",
  "Sells": "Sells",
  "Sells and Buys": "Sells and Buys",
  "SEMESTER": "Semester",
  "Send": "Send",
  "Send document": "Send document",
  "Sénegal": "Sénegal",
  "Sénégal": "Sénégal",
  "SEPA Credential Identifier": "SEPA Credential Identifier",
  "Separated by:": "Separated by:",
  "Service": "Service",
  "Service type": "Service type",
  "Services": "Services",
  "Services by Company": "Services by Company",
  "Services by User": "Services by User",
  "Settings": "Settings",
  "Settings saved successfully": "Settings saved successfully",
  "Shares Types": "Shares Types",
  "Short name": "Short name",
  "Short Name": "Short Name",
  "Shortname": "Shortname",
  "Show more": "Show more",
  "Siren": "Siren",
  "Siren must have 9 digits": "Siren must have 9 digits",
  "Size": "Size",
  "Skiped": "Skiped",
  "Social": "Social",
  "Social Dossier": "Social Dossier",
  "Software": "Software",
  "Some banks will be removed because they are duplicates": "Some banks will be removed because they are duplicates",
  "Some fields need atention": "Some fields need atention",
  "Specific Info": "Specific Info",
  "SSI progress": "SSI progress",
  "SSI type": "SSI type",
  "SSI Type": "SSI Type",
  "Stakeholder": "Stakeholder",
  "Stakeholders": "Stakeholders",
  "Start": "Start",
  "Start balance review": "Start balance review",
  "Start date": "Start date",
  "Start Date": "Start Date",
  "Start of exercise": "Start of exercice",
  "Start this bulk": "Start this bulk",
  "Start time": "Start time",
  "Statistics": "Statistics",
  "Status": "Status",
  "Statuus:": "Statuus:",
  "std": "Collaborater",
  "Structural overtime": "Structural overtime",
  "Submit": "Submit",
  "Submited by": "Submited by",
  "Subrogation des IJSS": "Subrogation des IJSS",
  "Subscribe": "Subscribe",
  "Subscribed": "Subscribed",
  "Subsidiaries": "Subsidiaries",
  "Subsidiary Type": "Subsidiary Type",
  "Success": "Success",
  "Successful synchronisation": "Successful synchronisation",
  "Successfully created": "Successfully created",
  "Successfully removed": "Successfully removed",
  "Suggestion counterpart": "Suggestion counterpart",
  "Suggestion counterpart code": "Suggestion counterpart code",
  "Sunday": "Sunday",
  "sup": "Super user",
  "SURVEILLANCE": "Surveillance",
  "Sync Transactions": "Sync Transactions",
  "Table chart": "Table chart",
  "Tax collection": "Tax collection",
  "Tax obligations references": "Tax obligations references",
  "Taxation": "Taxation",
  "TDFC": "TDFC",
  "Terminate connection": "Terminate connection",
  "Thank you": "Thank you",
  "The bank that you're looking for does not exist": "The bank that you're looking for does not exist",
  "The data was saved successfully": "The data was saved successfully",
  "The data was successfully saved, it may take a few minutes to apply the collaborative services to all companies and their employees.": "The data was successfully saved, it may take a few minutes to apply the collaborative services to all companies and their employees.",
  "The exercise year ended": "The exercice year ended",
  "The file was not imported": "The file was not imported",
  "The Firm": "The Firm",
  "The input is not valid e-mail!": "The input is not valid e-mail!",
  "The page you are looking for does not exist or has been moved.": "The page you are looking for does not exist or has been moved.",
  "The user will receive an email with a link to reset their password": "The user will receive an email with a link to reset their password",
  "There are no documents to export": "There are no documents to export",
  "There are no documents to export in FACT": "There are no documents to export in FACT",
  "There are no documents to export in NCS": "There are no documents to export in NCS",
  "There are no documents to export in NeoCheque": "There are no documents to export in NeoCheque",
  "There are no documents to export in NeoTreso": "There are no documents to export in NeoTreso",
  "There are no documents to export in SSI": "There are no documents to export in SSI",
  "There is an error loading the data, please refresh the page or click the button below.": "There is an error loading the data, please refresh the page or click the button below.",
  "There is an error loading the data, please refresh the page.": "There is an error loading the data, please refresh the page.",
  "There is an error, please refresh the page or click the button below.": "There is an error, please refresh the page or click the button below.",
  "There is no connection": "There is no connection",
  "There is no data to display": "There is no data to display",
  "These accounts are connected to your bank, allowing monthly transactions to be automatically retrieved": "These accounts are connected to your bank, allowing monthly transactions to be automatically retrieved",
  "These accounts are purely informative; there is no link with your bank": "These accounts are purely informative; there is no link with your bank",
  "Third-part accounts lenght": "Third-part accounts lenght",
  "This action delete the company and all the information it contains. There is no going back": "This action delete the company and all the information it contains. There is no going back",
  "This action will disable the bank account and all associated transactions. Are you sure you want to disable this bank account?": "This action will disable the bank account and all associated transactions. Are you sure you want to disable this bank account?",
  "This action will permanently delete the bank account and all associated transactions. Are you sure you want to delete this bank account?": "This action will permanently delete the bank account and all associated transactions. Are you sure you want to delete this bank account?",
  "This field is required": "This field is required",
  "This field is required or invalid format.": "This field is required or invalid format.",
  "This field is required.": "This field is required.",
  "This field must be a valid url": "This field must be a valid url",
  "This field only accept numbers": "This field only accept numbers",
  "Thursday": "Thursday",
  "Tiers": "Tiers",
  "Time": "Time",
  "Time Length": "Time Length",
  "Time limit": "Time limit",
  "Timezone": "Timezone",
  "to": "to",
  "to cycle ": "to cycle ",
  "Today": "Today",
  "Total": "Total",
  "Total articles": "Total articles",
  "Total articles_one": "Total articles",
  "Total articles_other": "Total articles",
  "Total articles_plural": "Total articles",
  "Total cumulative sales": "Total cumulative sales",
  "Total Customers period": "Total Customers period",
  "Total docs registered": "Total docs registered",
  "Total docs validated": "Total docs validated",
  "Total documents": "Total documents",
  "Total Documents": "Total Documents",
  "Total sales cashed": "Total sales cashed",
  "Total table items": "Total table items",
  "Total table items_one": "Total {{count}} item",
  "Total table items_other": "Total {{count}} items",
  "Total table items_plural": "Total table items",
  "Transactions imported successfully": "Transactions imported successfully",
  "Treasury": "Treasury",
  "Treasury IS": "Treasury IS",
  "Treated": "Treated",
  "Trésorerie": "Trésorerie",
  "Trimest": "Trimest",
  "TS": "TS",
  "TTC": "TTC",
  "Tuesday": "Tuesday",
  "Turnover to be declared": "Turnover to be declared",
  "TVA": "TVA",
  "TVA sur": "TVA sur",
  "Two-factor authentication": "Two-factor authentication",
  "Type": "Type",
  "Un lock": "Un lock",
  "Unauthorized": "Unauthorized",
  "Undo": "Undo",
  "Unexpected error": "Unexpected error",
  "Unexpected Error": "Unexpected Error",
  "Unit measure": "Unit measure",
  "Unit price": "Unit price",
  "Unsubscribe": "Unsubscribe",
  "Unsubscribed": "Unsubscribed",
  "Update": "Update",
  "Update address": "Update address",
  "Update bank": "Update bank",
  "Update Collecting Organization": "Update Collecting Organization",
  "Update custom graphic": "Update custom graphic",
  "Update Establishment": "Update Establishment",
  "Update Worktime": "Update Worktime",
  "Updated": "Updated",
  "Updated by": "Updated by",
  "updated successfully": "updated successfully",
  "Upload your file": "Upload your file",
  "Uploaded to Interops": "Uploaded to Interops",
  "Upon receipt of SS Indemnities": "Upon receipt of SS Indemnities",
  "Use the government mileage scales": "Use the government mileage scales",
  "Use URL file in export": "Use URL file in export",
  "User": "User",
  "User access": "User access",
  "User Access": "User Access",
  "User category": "User category",
  "User Category": "User Category",
  "User data": "User data",
  "User info": "User info",
  "User Type": "User Type",
  "Username": "Username",
  "Users": "Users",
  "Validate": "Validate",
  "Validated": "Validated",
  "value": "value",
  "Vat": "Vat",
  "VAT": "VAT",
  "VAT amount": "VAT amount",
  "VAT autoliquidation": "VAT autoliquidation",
  "VAT declaration": "VAT declaration",
  "Vat number": "Vat number",
  "Vat Number": "Vat Number",
  "Vat Saved with Success": "Vat Saved with Success",
  "VAT to be regularized": "VAT to be regularized",
  "Vats": "Vats",
  "Vats control": "Vats control",
  "Warnings": "Warnings",
  "Web Site": "Web Site",
  "Website": "Website",
  "Wednesday": "Wednesday",
  "Without access": "Without access",
  "Work shift": "Work shift",
  "Work time": "Work time",
  "Worktime": "Worktime",
  "WorkTime": "WorkTime",
  "Write a comment...": "Write a comment...",
  "YEARLY": "Yearly",
  "Yes": "Yes",
  "YES": "YES",
  "You are logged out": "You are logged out",
  "You can only upload JPG/PNG file!": "You can only upload JPG/PNG file!",
  "You do not have access to any company, please contact the accounting firm administrator": "You do not have access to any company, please contact the accounting firm administrator",
  "You have succesfully set up two-factor authentication": "You have succesfully set up two-factor authentication",
  "You have unsaved changes, are you sure you want to leave?": "You have unsaved changes, are you sure you want to leave?",
  "You must add the user to a company": "You must add the user to a company"
}
